import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
})
export class PopupComponent implements OnInit {
  @Input() title: any;
  @Input() image: any;
  @Input() buttons: any;
  @Input() small: any;
  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {}

  close(){
    this.modalController.dismiss();
  }

}
